export default 
[
    // Models
    {
        name : 'workDenSceneMerged001',
        type :'dracoGltfModel',
        path :'models/Workden/workDenSceneMerged.001.glb'
    },
    {
        name : 'workDenSceneMerged002',
        type :'dracoGltfModel',
        path :'models/Workden/workDenSceneMerged.002.glb'
    },    
    {
        name : 'workDenSceneMaterialMappedObjects',
        type : 'dracoGltfModel',
        path : 'models/Workden/workDenSceneMaterialMappedObjects.glb'
    },
    {
        name : 'workDenSceneMergedPhotoTextureObjects',
        type :'dracoGltfModel',
        path :'models/Workden/workDenSceneMergedPhotoTextures.glb'
    },
    {
        name : 'workDenSceneMiscObjects',
        type :'dracoGltfModel',
        path :'models/Workden/workDenSceneMiscObjects.glb'
    },
    {
        name : 'cat',
        type :'dracoGltfModel',
        path :'models/Workden/lowPolyCatAnimated.glb'
    },
    // Baked Textures    
    // {
    //     name : 'cricketEquipmentMergedTexture',
    //     type : 'texture',
    //     path : 'textures/baked/cricketEquipmentMergedTexture.jpg'
    // },
    // {
    //     name : 'workDenSceneMergedTexture001',
    //     type : 'texture',
    //     path : 'textures/baked/workDenSceneMergedTexture001.jpg'
    // },
    // {
    //     name : 'workDenSceneMergedTexture002',
    //     type : 'texture',
    //     path : 'textures/baked/workDenSceneMergedTexture002.jpg'
    // },
    // {
    //     name : 'workDenSceneMergedPhotoTexturesBaked',
    //     type : 'texture',
    //     path : 'textures/baked/workDenSceneMergedPhotosTexture.jpg'
    // },
    {
        name : 'workDenSceneMergedTexture001',
        type : 'KTX2texture',
        path : 'textures/baked/workDenSceneMergedTexture001.ktx2'
    },
    {
        name : 'workDenSceneMergedTexture002',
        type : 'KTX2texture',
        path : 'textures/baked/workDenSceneMergedTexture002.ktx2'
    },
    {
        name : 'workDenSceneMergedPhotoTexturesBaked',
        type : 'KTX2texture',
        path : 'textures/baked/workDenSceneMergedPhotosTexture.ktx2'
    },
    {
        name : 'cricketEquipmentMergedTexture',
        type : 'KTX2texture',
        path : 'textures/baked/cricketEquipmentMergedTexture.ktx2'
    },
    // Unbaked Textures
    {
        name : 'stickyNoteBackArrowTexture',
        type : 'texture',
        path : 'textures/BackArrow.jpg'
    },
    {
        name : 'resumeTexture',
        type : 'texture',
        path : 'textures/unbaked/NikhilCV.jpg'
    },
    {
        name : 'resumeAbridgedTexture',
        type : 'texture',
        path : 'textures/unbaked/NikhilCVabridged.jpg'
    },
    {
        name : 'openFileButtonTexture',
        type : 'texture',
        path : 'textures/OpenFile.jpg'
    },
    {
        name : 'closeButtonTexture',
        type : 'texture',
        path : 'textures/Cancel.jpg'
    },
    {
        name : 'kurzgezagtLogoTexture',
        type : 'texture',
        path : 'textures/unbaked/Kurzgesagt.png'
    },
    {
        name : 'firewatchWallpaperTexture',
        type : 'texture',
        path : 'textures/unbaked/FirewatchWallpaper.jpg'
    },
    {
        name : 'firewatchWallpaperTextureBlurred',
        type : 'texture',
        path : 'textures/unbaked/FirewatchWallpaperBlurredDownscaled.jpg'
    },
    {
        name : 'phoneScreenTexture',
        type : 'texture',
        path : 'textures/unbaked/PhoneScreen.jpg'
    },
    {
        name : 'treePaintingTexture',
        type : 'texture',
        path : 'textures/unbaked/TreeSketch.jpg'
    },
    {
        name : 'perlinNoiseTexture',
        type : 'texture',
        path : 'textures/PerlinNoiseTexture.png'
    },
    // {
    //     name : 'catMimiTexture',
    //     type : 'texture',
    //     path : 'textures/unbaked/CatMimiTexture.jpg'
    // },
    {
        name : 'catMimiTexture',
        type : 'KTX2texture',
        path : 'textures/unbaked/CatMimiTexture.ktx2'
    },
    {
        name : 'letterZTexture',
        type : 'texture',
        path : 'textures/LetterZ.png'
    },
    // Audio Files
    {
        name : 'catMeowSound1',
        type : 'audio',
        path : 'sounds/steffCaffreyCatMeow1.wav'
    },
    {
        name : 'catMeowSound2',
        type : 'audio',
        path : 'sounds/steffCaffreyCatMeow2.wav'
    },
    {
        name : 'catMeowSound3',
        type : 'audio',
        path : 'sounds/steffCaffreyCatMeow3.wav'
    },
    {
        name : 'workdenBackgroundNoise',
        type : 'audio',
        path : 'sounds/workdenBackgroundNoise.wav'
    },
    {
        name : 'clickSound1',
        type : 'audio',
        path : 'sounds/clickSound01.wav'
    }
    // {
    //     name : 'clickSound2',
    //     type : 'audio',
    //     path : 'sounds/clickSound02.wav'
    // }

]